"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
const types_1 = require("./types");
exports.routes = (0, types_1.buildRoutes)({
    workflowDefinition: {
        path: "/workflows/:workflowDefinitionId/overview",
    },
    listWorkflows: {
        path: "/workflows/:workflowDefinitionId",
    },
    workflow: {
        path: "/workflow/:workflowId",
    },
    workflowsTable: {
        path: "/workflows/:workflowDefinitionId/table",
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid29ya2Zsb3dzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vcm91dGluZy93b3JrZmxvd3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsbUNBQXNDO0FBRXpCLFFBQUEsTUFBTSxHQUFHLElBQUEsbUJBQVcsRUFBQztJQUNoQyxrQkFBa0IsRUFBRTtRQUNsQixJQUFJLEVBQUUsMkNBQTJDO0tBQ2xEO0lBQ0QsYUFBYSxFQUFFO1FBQ2IsSUFBSSxFQUFFLGtDQUFrQztLQUN6QztJQUNELFFBQVEsRUFBRTtRQUNSLElBQUksRUFBRSx1QkFBdUI7S0FDOUI7SUFDRCxjQUFjLEVBQUU7UUFDZCxJQUFJLEVBQUUsd0NBQXdDO0tBQy9DO0NBQ0YsQ0FBQyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgYnVpbGRSb3V0ZXMgfSBmcm9tIFwiLi90eXBlc1wiO1xuXG5leHBvcnQgY29uc3Qgcm91dGVzID0gYnVpbGRSb3V0ZXMoe1xuICB3b3JrZmxvd0RlZmluaXRpb246IHtcbiAgICBwYXRoOiBcIi93b3JrZmxvd3MvOndvcmtmbG93RGVmaW5pdGlvbklkL292ZXJ2aWV3XCIsXG4gIH0sXG4gIGxpc3RXb3JrZmxvd3M6IHtcbiAgICBwYXRoOiBcIi93b3JrZmxvd3MvOndvcmtmbG93RGVmaW5pdGlvbklkXCIsXG4gIH0sXG4gIHdvcmtmbG93OiB7XG4gICAgcGF0aDogXCIvd29ya2Zsb3cvOndvcmtmbG93SWRcIixcbiAgfSxcbiAgd29ya2Zsb3dzVGFibGU6IHtcbiAgICBwYXRoOiBcIi93b3JrZmxvd3MvOndvcmtmbG93RGVmaW5pdGlvbklkL3RhYmxlXCIsXG4gIH0sXG59KTtcbiJdfQ==